import styled from '@emotion/styled';

const ChartSVG = styled.svg`
  width: 100%;
  height: 300px;
  overflow: visible;
  @media screen and (max-width: 860px) {
    margin-top: 4rem;
  }
`;

const LegendContainer = styled.div`
  display: flex;
  position: absolute;
  @media screen and (max-width: 320px) {
    right: 0;
  }
  @media screen and (max-width: 860px) {
    flex-direction: column;
    width: 300px;
  }
`;

const LegendBlock = styled.div`
  text-align: start;
  position: relative;
  display: flex;
  margin: 0.5rem;
  flex-direction: column;
  padding-left: 35px;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: normal;
  color: #293040;
`;

const LegendColor = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 5px;
  background-color: ${(props) => props.sqcolor};
  left: 7px;
  top: 8px;
`;

const AccountInfo = styled.div`
  display: flex;
  align-items: flex-end;
  font-size: 18px;
  div:first-of-type {
    font-size: 30px;
    font-weight: 700;
    line-height: 1em;
    color: #44b04f;
  }
  div:nth-of-type(2) {
    font-size: 22px;
    margin-right: 0.5rem;
    color: #44b04f;
  }
  @media screen and (max-width: 1023px) {
    font-size: 16px;
    div:first-of-type {
      font-size: 26px;
      font-weight: 700;
      line-height: 1em;
      color: #44b04f;
    }
    div:nth-of-type(2) {
      font-size: 18px;
      margin-right: 0.5rem;
      color: #44b04f;
    }
  }
`;

const LegendValue = styled.div`
  font-size: 24px;
  font-weight: 600;
  margin-top: 0.2rem;
  color: #233143;
  @media screen and (max-width: 1023px) {
    font-size: 20px;
  }
`;

const MouseDetectionArea = styled.rect`
  stroke: s#f00;
  fill: transparent;
`;

const AxisText = styled.text`
  font-size: 14px;
  fill: ${({ theme }) => theme.black};
`;
const StaticAxisText = styled(AxisText)`
  font-size: 14px;
  fill: ${({ theme }) => theme.secondary};
  transition: opacity 0.2s ease-in-out;
  opacity: ${({ hide }) => (hide ? 0 : 1)};
`;

const SliderAndLegendContainer = styled.div`
  max-width: 100%;
  margin: auto;
  z-index: -1;
`;

const InitialFundsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2rem;
  align-items: center;
  div:first-of-type {
    color: ${({ theme }) => theme.grey};
    font-size: 16px;
  }
  div:last-child {
    color: #233143;
    font-size: 38px;
    line-height: 52px;
    font-weight: 600;
  }
`;

const calculateSliderProgress = (value: any, max: any) => {
  const result: number = (value * 100) / max;
  return result;
};

const SlideInput = styled.input`
  position: relative;
  display: block;
  -webkit-appearance: none; /* Override default CSS styles */
  appearance: none;
  width: 100%; /* Full-width */
  margin: auto;
  height: 2px; /* Specified height */
  background: ${({ value, max }) =>
    `linear-gradient(to right, #44B04F 0%, #44B04F ${calculateSliderProgress(
      value,
      max,
    )}%, rgba(40, 39, 37, 0.1) ${calculateSliderProgress(
      value,
      max,
    )}%, rgba(40, 39, 37, 0.1) 100%)`}; /* Grey background */
  outline: none; /* Remove outline */
  margin-bottom: 2rem;
  &::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 16px; /* Set a specific slider handle width */
    height: 16px; /* Slider handle height */
    border-radius: 16px;
    background: #fff; /* Green background */
    border: 1px solid #eee;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.35);
    cursor: pointer; /* Cursor on hover */
  }
  :-webkit-slider-runnable-track {
    height: 10px;
    -webkit-appearance: none;
    color: #13bba4;
    margin-top: -1px;
  }
`;

export {
  ChartSVG,
  LegendColor,
  LegendBlock,
  LegendContainer,
  AccountInfo,
  LegendValue,
  MouseDetectionArea,
  AxisText,
  StaticAxisText,
  InitialFundsContainer,
  SlideInput,
  SliderAndLegendContainer,
};
